import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_Single from "./gui/GUIset_Single";
import Template from "./TheTemplate";

const Partition = () => {
	useEffect(() => {
		document.title =
			"Partition Problem: given a set of positive integers, check if it can be divided into two subsets with equal sum.";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("3,1,1,2,2,1");
	// const [guiTxt1, guiTxtChange1] = useState("3,1,2,1,1");
	// const [guiTxt1, guiTxtChange1] = useState("1,5,11,5");
	// const [guiTxt1, guiTxtChange1] = useState("1,5,5,11");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			process();
			BuildResult();
			arr_input = [];
			memory = []; // int[][]
		}
	};

	var txt_time = "";
	var txt_time2 = "";
	var result = true; //boolean
	var arr_input = [];
	var memory = []; // int[][]
	// var bigO = 0;//no use
	var sum1 = 0;

	function process() {
		arr_input = T.str_toListInt(guiTxt1);
		// bigO = 0;
		var n = arr_input.length;
		sum1 = T.arr_getSUM(arr_input);
		console.log("Arr: " + arr_input);
		console.log("Sum: " + sum1);
		memory = T.getMatrix(n + 1, sum1 + 1, -999);
		//----------------------
		Timer.start();
		result = checkIfPartitionPossible(n, sum1, 0);
		txt_time = Timer.stop_print();

		//----------------------
		if (result == true) {
			Timer.setTimeBudget(4999);
			Timer.start();
			findPartition(sum1 / 2);
			txt_time2 = Timer.stop_print();
			if (Timer.timeReachLimit) {
				txt_time2 += " (timeout)";
			}
		}
		// console.log("result " + result + " " + bigO);
		// console.log("CHECK: \n" + T.matrix_print(memory));
		// console.log("LIST: \n" + partition_list1);
		// console.log("LIST: \n" + partition_list2);
	}

	//STEP 1 ------------------------------------------
	//add item from List 1 to List 2, sum of list 2 is sum
	// return Boolean
	function checkIfPartitionPossible(n, sum1, sum2) {
		if (n == 0) {
			if (sum1 == sum2) {
				return true;
			} else {
				return false;
			}
		}
		if (memory[n][sum1] == 1) {
			return true;
		} else if (memory[n][sum1] == 0) {
			return false;
		}
		var result =
			checkIfPartitionPossible(
				n - 1,
				sum1 - arr_input[n - 1],
				sum2 + arr_input[n - 1]
			) || checkIfPartitionPossible(n - 1, sum1, sum2);
		if (result) {
			memory[n][sum1] = 1;
		}
		{
			memory[n][sum1] = 0;
		}
		// bigO++;
		return result;
	}

	//STEP 2 ------------------------------------------
	var partition_target = 0;
	var partition_found = false;
	var partition_arr1 = [];
	var partition_arr2 = [];
	var sum_fromhere = []; //for optimization: help skip unnecessary processing
	var maxsum_optimize = true;

	function findPartition(target) {
		console.log("Find Partitions, Target = " + target);
		partition_target = target;
		//for optimize
		sum_fromhere = T.arr_calSumFromHere(arr_input);
		console.log("limit = " + sum_fromhere);
		//
		findPartition_add(0, [], 0);
		partition_arr2 = T.arr_subtract_subset_inOrder(arr_input, partition_arr1);
	}

	function findPartition_add(sum1, list1, pointer) {
		//Part1: Termination =======================================
		if (partition_found) {
			return;
		}
		if (Timer.timeout()) {
			return;
		}
		// console.log(list1 + " SUM " + sum1 + " point " + pointer);
		console.log(list1 + " >> SUM " + sum1);
		if (sum1 == partition_target) {
			partition_found = true;
			partition_arr1 = list1;
			console.log("FOUND ");
		}
		if (
			partition_found ||
			sum1 >= partition_target ||
			pointer >= arr_input.length
		) {
			// console.log(" END ");
			return;
		}
		//Part2: Optimization (Can be removed) =======================================
		if (maxsum_optimize) {
			var maxsum = sum1 + sum_fromhere[pointer];
			if (maxsum == partition_target) {
				partition_found = true;
				// partition_arr1 = list1;
				// partition_arr1.push(...arr.slice(pointer,arr.length));//push all
				partition_arr1 = T.arr_concat_select(
					list1,
					arr_input,
					pointer,
					arr_input.length
				);
				console.log(
					partition_arr1 +
						" >> SUM " +
						partition_target +
						" by maxsum optimization"
				);
				console.log("FOUND");
				return;
			}
			if (sum1 + sum_fromhere[pointer] < partition_target) {
				return; //optiize: no need to try because even sum all from here is lower than target value
			}
		}
		//Part3: Recursion =======================================
		var a = arr_input[pointer];
		var list1n = T.arr_cloneAdd(list1, a);
		if (pointer < arr_input.length - 1) {
			findPartition_add(sum1, list1, pointer + 1);
		} //not add
		findPartition_add(sum1 + a, list1n, pointer + 1); //add
	}

	//---------------------------------------------

	function BuildResult() {
		var txt;
		var txt3;
		if (result) {
			txt = `Partitioning is possible (${partition_target} x 2)`;
			txt3 =
				"Partition 1 : " + partition_arr1 + "\nPartition 2 : " + partition_arr2;
		} else {
			txt = `Partitioning is not possible (sum = ${sum1})`;
			txt3 = "Partition 1 : undefined\nPartition 2 : undefined";
		}
		if(maxsum_optimize) { txt_time2 += " (optimized)"; }
		//
		var part1 = Template.simple3size(
			"key1",
			"Result",
			txt,
			txt_time,
			22,
			20,
			17
		);
		var part2 = Template.simple3size(
			"key1",
			"Partitions",
			txt3,
			txt_time2,
			22,
			20,
			17
		);

		partResultChange(
			<div>
				{part1}
				{/* <br /> */}
				{part2}
			</div>
		);
	}

	return (
		<GUIset_Single
			title={"Partition Problem"}
			desc={
				"Given a set of positive integers, check if it can be divided into two subsets with equal sum."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Array"}
			txtButton={"Check"}
			// isNumOnly = {true}
		/>
	);
};

export default Partition;

//The partition problem is a special case of the Subset Sum Problem, which itself is a special case of the Knapsack Problem. T
